import { units } from '@m/alchemy-ui/theme';
import styled, { css } from 'styled-components';

export const FormField = styled.div`
  padding: 15px 0;
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.expressiveNegativeBase};
  font-size: ${props => props.theme.fontSizes.small};
`;

export const Label = styled.div`
  font-size: ${props => props.theme.fontSizes.medium};
  color: ${props => props.theme.colors.stellaBlack};
  font-weight: 700;
  margin-bottom: 7px;
`;

export const Tip = styled.p`
  font-size: ${props => props.theme.fontSizes.small};
  padding: 0;
  color: ${props => props.theme.colors.stellaPlaceholder};
`;

export const ModalContainer = styled.div`
  background: ${props => props.theme.colors.white};
  display: grid;
  height: 100vh;
  padding: 30px;
  overflow-y: auto;
  z-index:1001;
`;

export const ModalContentWrapper = styled.div`
  padding-bottom: 120px;
`;

export const ModalFooter = styled.div`
  position: absolute;
  background-color: ${props => props.theme.colors.white};
  border-top: 1px solid ${props => props.theme.colors.borderGray};
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 24px 24px 60px;
  text-align: right;
  z-index: 100;
  button {
    margin: 0 ${units(0.5)};
  }
`;

export const Button = styled.button`
  color: ${props => props.theme.colors.structuralConstructiveBase};
  border: 1px solid ${props => props.theme.colors.structuralConstructiveBase};
  background: ${props => props.theme.colors.white};
  padding: 14px 16px;
  font-size: ${props => props.theme.fontSizes.smallish};
  font-weight: ${props => props.theme.fontWeights.medium};

  ${props =>
    props.disabled &&
    css`
    border: 1px solid ${props.theme.colors.borderGray};
    color: ${props.theme.colors.borderGray};
  `}
`;

export const LinkButton = styled.a`
  color: ${props => props.theme.colors.structuralConstructiveBase};
  border: 1px solid ${props => props.theme.colors.structuralConstructiveBase};
  background: ${props => props.theme.colors.white};
  padding: 14px 16px;
  font-size: ${props => props.theme.fontSizes.smallish};
  font-weight: ${props => props.theme.fontWeights.medium};
`;

export const CancelButton = styled.button`
  border: 1px solid transparent;
  background-color: transparent;
  font-size: ${props => props.theme.fontSizes.smallish};
  padding: 4px 12px;
  text-align: center;
  color: ${props => props.theme.colors.darkGray};
  padding: 12px 32px;
  margin-right: 30px;
  &:hover {
    border: 1px solid ${props => props.theme.colors.transparentGray};
  }
`;

export const ModalHeading = styled.div`
  h1{
    text-transform: uppercase;
    font-style: normal;
    font-weight: 700;
    font-size: ${props => props.theme.fontSizes.largish};
    line-height: 20px;
    color: ${props => props.theme.colors.stellaNavy};
  }
`;

export const OptionsContainer = styled.div`
  border: 1px solid ${props => props.theme.colors.transparentGray};
  border-bottom: none;
  position: absolute;
  top: -8px;
  background: ${props => props.theme.colors.white};
  min-width: 160px;
  z-index: 10;
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    li {
      list-style: none;
      cursor: pointer;
      padding: 5px 10px;
      border-bottom: 1px solid ${props => props.theme.colors.transparentGray};
      min-height: 48px;
      background: ${props => props.theme.colors.white};
      display: flex;
      justify-content: start;
      align-items: center;
      &:hover, &:hover a {
        color: ${props => props.theme.colors.structuralConstructiveBase};
      }
      span {
        margin-left: 10px;
      }
      a {
        color: ${props => props.theme.colors.stellaBlack};
      }
    }
  }
`;

export const SlidingContainer = styled.div`
  overflow: hidden;
  max-height: 0;
  transition: max-height .4s ease-in-out;
  ${props =>
    props.opened &&
    css`
    max-height: 300px;
  `}
`;

export const Icon = styled.i`
  color: ${props => props.theme.colors.structuralConstructiveBase};
`;

export const ArrowDownIcon = styled.i`
  color: ${props => props.theme.colors.structuralConstructiveBase};
  padding: 0 8px;
`;

export const LoaderHolder = styled.div`
  height: 25px;
  width: 100%;
  text-align: center;
  overflow: hidden;
`;
